import {
    MODIFYMERCHANT_SUCCESS,
    MODIFYMERCHANT_FAILED,
    RESET_MODIFYMERCHANT,
    LOADING_MODIFYMERCHANT,
    NETWORK_ERROR_MODIFYMERCHANT
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_MODIFYMERCHANT:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case MODIFYMERCHANT_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case MODIFYMERCHANT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_MODIFYMERCHANT:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_MODIFYMERCHANT:
            return (state = initialState);
        default:
            return state;
    }
};
